
define('ldsh!modules/editor/templates/controls/resize_top', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="handle tl" id="lpg-nw"></div>\n<div class="handle tc" id="lpg-n"></div>\n<div class="handle tr" id="lpg-ne"></div>\n';

}
return __p
};});

